'use strict';

import * as THREE from 'three';
import { Buildings, isMobile, settingsData, threeJsVariables } from '../../settings';
import {
    lazyLoadingAll,
    lazyLoadingData, lockScreenForTablet,
} from '../../functions';
import {
    getCurrentCameraDistance,
    getOrbitControlsDistanceAndAngle, getOrbitControlsDistanceAndPan,
    rotateToCamera,
} from '../controls/orbitControls';
import {ViewMode} from "../../common";
import {bombButtonInitActionHandler} from "../controls/destroyBuilding";
import { getSelectionsByName } from '../threejs/autoSelectionBoxes'
import { Vector3 } from 'three';
import { Box3 } from 'three';
import { Group } from 'three';
import { Vector2 } from 'three';


export async function cylinderFloorNumbers() {
    if (threeJsVariables.scene.getObjectByName('cylinderFloorNumbers')) {
        return;
    }

    // const activeBuilding = buildings_info.find(building => building.isActive);
    const activeBuilding = Buildings.getActiveBuilding();
    const scene = threeJsVariables.scene;

    const cylinderFloorSliderGroup = new THREE.Group();
    cylinderFloorSliderGroup.name = 'cylinderFloorNumbers';

    const fontLoader = new THREE.FontLoader();
    const fontRegular = await lazyLoadingData(fontLoader, 'fonts/assistant/Assistant_Regular.json');
    const fontBold = await lazyLoadingData(fontLoader, 'fonts/assistant/Assistant_Bold.json');
    const allFonts = await lazyLoadingAll([fontRegular, fontBold]);

    const selectionBoxes = activeBuilding.selectionsGroup;
    THREE.Cache.enabled = true;

    // allFonts.then(resp => {
    //     const [fontRegular, fontBold] = resp;

        selectionBoxes.children.forEach(box => {
            switch (box.name.charAt(0)) {
                case 'F': {
                    const floorNumber = +box.name.split('_')[1];
                    const cylinderFloorElements = createFloorNumber(box, fontRegular, fontBold, floorNumber, selectionBoxes);
                    cylinderFloorSliderGroup.add(cylinderFloorElements);
                    break;
                }
                case 'R': break;
                case 'L': break;
                case 'S': break;
            }
        });
    // });

    scene.add(cylinderFloorSliderGroup);
}

function createFloorNumber(...options) {
    const [box, fontRegular, fontBold, floorNumber, selectionBoxes] = options;
    const floorNumbersSize = config.threejs.floorNumbers.size;
    const multiple = config.threejs.floorNumbers.multiple;

    const positionLeftOfBuilding = - 1;
    const baseElementsPosition = floorNumbersSize;
    let color = 0xffffff;

    (config?.resources?.background?.cylinderBg === 'sky') && (color = 0x000000);

    const parent = box.parent.name.split('_');

    // const selectionBoxesBox = new THREE.Box3().setFromObject(selectionBoxes);
    // const floorCenterSel = selectionBoxesBox.getCenter(new THREE.Vector3());
    const floorCenterSel = selectionBoxes.getWorldPosition(new Vector3());
    const boxSize = new Box3().setFromObject(box).getSize(new Vector3());
    const boxCenter = new Box3().setFromObject(box).getCenter(new Vector3());

    const apartments = box.children.filter(apt => !apt.name.startsWith(config.resources.selectionBoxes.floorPlugName) && !apt.name.startsWith(`${parent[0]}_amenity`));

    const apartmentsGroup = new Group();
    apartmentsGroup.position.set(box.position.x,box.position.y,box.position.z);

    for (let i = 0; i < apartments.length; i++){
        const cloneApt = apartments[i].clone();
        apartmentsGroup.add(cloneApt);
    }

    const apartmentsGroupBoxSize = new Box3().setFromObject(apartmentsGroup).getSize(new Vector3());
    const apartmentsGroupBoxCenter = new Box3().setFromObject(apartmentsGroup).getCenter(new Vector3());

    let minHeightApt = null;
    let floorBox, floorCenter;

    apartments.forEach(apt =>{
        const aptBox = new THREE.Box3().setFromObject(apt);
        const size = aptBox.getSize(new Vector3());
        if (Math.floor(size.y) !== Math.floor(apartmentsGroupBoxSize.y)){
            minHeightApt = apt;
        }
    });

    if (!minHeightApt){
        floorBox = new THREE.Box3().setFromObject(apartments[0]);
        floorCenter = floorBox.getCenter(new THREE.Vector3());
    } else {
        floorBox = new THREE.Box3().setFromObject(minHeightApt);
        floorCenter = floorBox.getCenter(new THREE.Vector3());

        apartmentsGroupBoxCenter.y = apartmentsGroupBoxCenter.y + selectionBoxes.position.y;

        if (floorCenter.y < apartmentsGroupBoxCenter.y){
            floorCenter = new Vector3(floorCenter.x,apartmentsGroupBoxCenter.y,floorCenter.z);
        }

    }

    // const floorCenterBox = selectionBoxesBox.getSize(new THREE.Vector3());
    // console.log(floorCenterBox);

    const floorElements = new THREE.Group();
    floorElements.name = 'floorElements';
    floorElements.position.set(floorCenterSel.x, floorCenter.y, floorCenterSel.z);
    // floorElements.userData.floorIndex = floorNumber - config.resources.selectionBoxes.floorNumberCorrection;
    floorElements.userData.floorIndex = floorNumber;
    floorElements.userData.floor = floorNumber;

    const floorNumberBool = !(floorNumber % multiple);
    const size = (floorNumberBool) ? 1.3 : 1;
    const font = (floorNumberBool) ? fontBold : fontRegular;

    const isBuildingOpacity = Boolean(config.features.buildingOpacity);

    const shapes = font.generateShapes(`${floorNumber}`, size);
    const geometry = new THREE.ShapeBufferGeometry(shapes);
    const material = new THREE.MeshBasicMaterial({color, transparent: isBuildingOpacity});
    const number = new THREE.Mesh(geometry, material);

    const textPositionCorrection = (floorNumber < multiple && floorNumber !== 0) ? size * 0.5 : 0;
    const positionNotBoldCorrection = (!floorNumberBool) ? size : 0;
    number.position.set(0, 0.5, (baseElementsPosition - textPositionCorrection - positionNotBoldCorrection) * positionLeftOfBuilding );
    number.userData.defaultPosition = new Vector3(0, 0.5, (baseElementsPosition - textPositionCorrection - positionNotBoldCorrection) * positionLeftOfBuilding);
    number.rotation.y = Math.PI * -0.5;
    number.name = `floor-${floorNumber}`;

    const line = createLine(baseElementsPosition, positionLeftOfBuilding, color, positionNotBoldCorrection);
    const circle = createCircle(baseElementsPosition, positionLeftOfBuilding, size, number);

    floorElements.add(number);
    floorElements.add(line);
    floorElements.add(circle);

    floorElements.visible = (floorNumberBool);
    // floorElements.visible = false;

    return floorElements;
}

function createCircle(baseElementsPosition, positionLeftOfBuilding, size, number) {
    const geometryCircle = new THREE.CircleGeometry(size, 30);
    const materialCircle = new THREE.MeshBasicMaterial({
        transparent: true,
        opacity: 0
    });
    const circle = new THREE.Mesh(geometryCircle, materialCircle);
    circle.position.set(number.position.x + 0.2, 0, (baseElementsPosition - size) * positionLeftOfBuilding);
    circle.rotation.y = Math.PI * -0.5;
    circle.position.y = size;
    circle.name = 'circle';
    circle.visible = false;

    return circle;
}
function createLine(baseElementsPosition, positionLeftOfBuilding, color, positionNotBoldCorrection) {
    const materialLine = new THREE.LineBasicMaterial({
        color,
        transparent: true,
        opacity: 0.3
    });
    const geometryLine = new THREE.BufferGeometry().setFromPoints([
        new THREE.Vector3(0, 0, 0),
        new THREE.Vector3(0, 0, (baseElementsPosition - positionNotBoldCorrection) * positionLeftOfBuilding)
    ]);
    const line = new THREE.Line(geometryLine, materialLine);
    line.geometry.attributes.position.needsUpdate = true;
    line.name = 'line';

    return line;
}

// export function rotateCylinderFloorNumbers() {
//     if (settingsData.activeViewMode !== ViewMode.Cylinder && settingsData.destroyedMode) {
//         return;
//     }
//
//     const cylinderFloorNumbers = threeJsVariables.scene.getObjectByName('cylinderFloorNumbers');
//     if (!cylinderFloorNumbers) return;
//
//     cylinderFloorNumbers.children.forEach(item =>{
//         item.rotation.y = rotateToCamera();
//     });
// }

export function rotateCylinderFloorNumbers() {
    const cylinderFloorNumbers = threeJsVariables.scene.getObjectByName('cylinderFloorNumbers');
    if (!cylinderFloorNumbers) return;

    cylinderFloorNumbers.children.forEach(item =>{
        item.rotation.y = rotateToCamera();
    });
}

export function removeCylinderFloorNumbers() {
    const cylinderFloorNumbers = threeJsVariables.scene.getObjectByName('cylinderFloorNumbers');
    if (!cylinderFloorNumbers) return;
    threeJsVariables.scene.remove(cylinderFloorNumbers);
    cylinderFloorNumbers.traverse(e=>{
        if (e.isMesh || e.isLine){
            e.geometry.dispose();
            e.material.dispose();
        }
    })
}

let windowVector = new Vector2();
let canvasSize = new Vector2();

export function showOrHideCylinderFloorNumbers() {
    if (settingsData.activeViewMode !== ViewMode.Cylinder){
        return;
    }

    const floors = threeJsVariables.scene.getObjectByName('cylinderFloorNumbers');
    if (!floors) return;

    const currentCameraDistance = getCurrentCameraDistance();
    const {minDistance,maxDistance} = getOrbitControlsDistanceAndPan(ViewMode.Cylinder);
    const {currentMinDistance,currentMaxDistance} = getOrbitControlsDistanceAndAngle();
    const {activate,foreshortening} = config.threejs.orbitControls.autoZoomSettings;
    const multiple = config.threejs.floorNumbers.multiple;
    const size = config.threejs.floorNumbers.size;
    const resizeCoefficient = config.threejs.floorNumbers.resizeCoefficient ? config.threejs.floorNumbers.resizeCoefficient : 2;

    if (Math.ceil(currentMinDistance) !== Math.ceil(minDistance)){
        return;
    }

    let center;

    if (activate){
        center = foreshortening;
    } else {
        center = (maxDistance + minDistance) / 2;
    }


    floors.traverse(el => {
       if (el.name === 'floorElements'){
           if (currentCameraDistance <= center){
               el.visible = true;
           } else if (currentCameraDistance > center){
               el.visible = (el.userData.floor % multiple === 0);
           }
       } else if (isMobile && el.name.match(/floor/) ){

           const line = el.parent.getObjectByName('line');

           if (!settingsData.isLandscape){

               threeJsVariables.renderer.getSize(canvasSize);
               windowVector.set(window.innerWidth,window.innerHeight);

               if (canvasSize.equals(windowVector)){

                   const cubSize = Math.abs(size * 3);

                   if (currentCameraDistance < cubSize){
                       el.position.z = el.userData.defaultPosition.z + ((cubSize - currentCameraDistance) / (resizeCoefficient));
                       line.scale.z = 1 - ((cubSize - currentCameraDistance) / (resizeCoefficient * size));
                   } else {
                       el.position.set(el.userData.defaultPosition.x,el.userData.defaultPosition.y,el.userData.defaultPosition.z);
                       line.scale.z = 1;
                   }
               } else {
                   el.position.set(el.userData.defaultPosition.x,el.userData.defaultPosition.y,el.userData.defaultPosition.z);
                   line.scale.z = 1;
               }
           } else {
               el.position.set(el.userData.defaultPosition.x,el.userData.defaultPosition.y,el.userData.defaultPosition.z);
               line.scale.z = 1;
           }

       }
    });

    // for (const item of floors.children) {
    //     console.log(item);
    //     if (currentCameraDistance <= center){
    //         item.visible = true;
    //     } else if (currentCameraDistance > center){
    //         item.visible = (item.userData.floor % multiple === 0);
    //     }
    //     // if (isMobile){
    //     //     if (currentCameraDistance <=currentMinDistance + 3){
    //     //         item.visible = true;
    //     //     } else if (currentCameraDistance > currentMinDistance + 5 && currentCameraDistance < currentMaxDistance - 5){
    //     //         item.visible = (item.userData.floor % 10 === 0);
    //     //     } else if (currentCameraDistance >= currentMaxDistance - 1){
    //     //         item.visible = false;
    //     //     }
    //     // } else {
    //     //     if (currentCameraDistance <= currentMinDistance + 50){
    //     //         item.visible = true;
    //     //     } else if (currentCameraDistance > currentMinDistance + 60 && currentCameraDistance < currentMaxDistance - 15){
    //     //         item.visible = (item.userData.floor % 10 === 0);
    //     //     } else if (currentCameraDistance >= currentMaxDistance - 1){
    //     //         item.visible = false;
    //     //     }
    //     // }
    // }
}

export const cylinderFloorNumbersResize = () => {
    const windowWidth = window.innerWidth;
    const cylinderFloorNumbers = threeJsVariables.scene.getObjectByName('cylinderFloorNumbers');

    if (!cylinderFloorNumbers) return;

    cylinderFloorNumbers.traverse(item => {
        if (item.name === 'line') {
            console.log(item);
            let positions = item.geometry.attributes.position.array;

            const newPositions = positions.map(point => {
                if (point !== 0) {
                    point++;
                }
                return point;
            });

            // item.geometry.setAttribute('position', new THREE.BufferAttribute(newPositions, 2));
            // item.geometry.computeBoundingBox();
            // item.geometry.computeBoundingSphere();
            // console.log(item);
            // console.log(positions);
            // console.log(newPositions);
        }
    });
}

export function cylinderFloorNumbersIntersection(action) {
    if (settingsData.activeViewMode !== ViewMode.Cylinder && settingsData.destroyedMode) {
        return;
    }
    const {scene, raycaster} = threeJsVariables;
    const cylinderFloorNumbers = scene.getObjectByName('cylinderFloorNumbers');

    const intersects = (cylinderFloorNumbers)
        ? raycaster.intersectObjects(cylinderFloorNumbers.children, true)
        : [];

    if (intersects.length === 0) {
        document.body.style.cursor = '';
        return;
    }

    const object = intersects[0].object;

    if (object.parent.name === 'floorElements' && object.parent.visible && object.name !== 'line') {
        document.body.style.cursor = 'pointer';

        if (action === 'click') {
            document.body.style.cursor = '';

            const currentFloor = object.parent.userData.floorIndex;
            const activeBuilding = Buildings.getActiveBuilding();
            const apartment = activeBuilding.apartments.find(apt => apt.userData.floor === currentFloor);

            settingsData.currentFloor = currentFloor;
            settingsData.lastClickedFlat = apartment;

            bombButtonInitActionHandler();
        }
    }
}
